<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal maxWidth="5xl" [customTitle]="(id ? 'Editar' : 'Nueva') + ' familia'" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">
    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-6">

        <div class="grid grid-cols-1 gap-4">

            <custom-input [autofocus]="true" label="Código" type="text"
                [formControlItem]="saveForm.get('code')"
                [errorMessages]="{ codeTaken: 'Este código ya existe' }"></custom-input>

            <custom-input label="Nombre" type="text"
                [formControlItem]="saveForm.get('name')"></custom-input>

        </div>

    </form>
</app-custom-modal>
}